
if(document.querySelectorAll('.validate-form')) {
  addFormValidationListener();
}

if(document.querySelectorAll('.success-message-close')) {
  const toggles = document.querySelectorAll('.success-message-close');
  toggles.forEach(toggle => {
    toggle.addEventListener('click', successFormToggle)
  });
}

if(document.querySelectorAll('.failure-message-close')) {
  const toggles = document.querySelectorAll('.failure-message-close');
  toggles.forEach(toggle => {
    toggle.addEventListener('click', failureFormToggle)
  });
}

if(document.getElementById('booklet-manual-download')) {
  const manualDownload = document.getElementById('booklet-manual-download');
  manualDownload.addEventListener('click', manualDownloadBooklet)
}

function addFormValidationListener() {
  const forms = document.querySelectorAll('.validate-form');
  forms.forEach(form => {
      form.addEventListener('submit', validateForm);
});
}

function successFormToggle(e) {
  const targetToggle = e.target.closest('.success-message-container');
  targetToggle.classList.remove('open')
}

function failureFormToggle(e) {
  const targetToggle = e.target.closest('.failure-message-container');
  targetToggle.classList.remove('open')
}

async function validateForm(e) {
  e.preventDefault();

  const form = e.target;
  const field = Array.from(form.elements);

  field.forEach(i => {
    i.checkValidity()
  });

  if (!form.checkValidity()) {
    return;
  }
 
  let payload = {}
  const formData = new FormData(form);
  for(const pair of formData.entries()) {
    payload[pair[0]] = pair[1];
  }
  if(window.__ctm) {
    payload.visitor_sid = window.__ctm.config.sid;
    payload.gid = window.__ctm.config.gid;
    payload.aid = window.__ctm.config.aid; 
    payload.form_completion_location = window.__ctm.config.windowLocation;
  } else {
    payload.aid = '74005';
  }
  
  const result = await sendForm(payload, form);

  let reachesPayload = {...payload};
  if (payload.phone) { // for reaches
    reachesPayload.homePhone = payload.phone;
  }
  submitToReaches(reachesPayload, 'no_comm_from_public', 'received', 'nn_rehab_contact_form', 'nn_contact_form', 'not_scheduled');

  const messageId = result.ok // As is sending to an AWS SQS
    ? result.data?.SendMessageResponse?.SendMessageResult?.MessageId
    : null;
  
  if (messageId) {
      if(form.classList.contains('download')) { // Either downloads and redirects or gives a thank you
        downloadBooklet(form.dataset.booklet, form.dataset.lang);
      } else {
        form.querySelector('.success-message-container').classList.add('open');
      }
      form.reset();
  } else {
      form.querySelector('.failure-message-container').classList.add('open');
  }
  
}

function manualDownloadBooklet(e) {
  let downloadType = e.target.dataset.booklet
  let downloadLang = e.target.dataset.lang
  downloadBooklet(downloadType, downloadLang);
}

async function sendForm(payload) {
  try {
    const response = await fetch('https://api.sbcdevsite.org/toctm', {
      method: 'POST',
      body: JSON.stringify(payload), 
      headers: {
        'Origin': '*', 
        'Content-Type': 'application/json'
      }
    });
    const responseBody = await response.json();
    return {
      ok: response.ok, 
      status: response.status,
      data: responseBody,
    }
  } catch (error) {
    console.error(error);
    return {
      ok: false, 
      status: 0, 
      data: null,
      error: error,
    }
  }
}

function submitToReaches(payload, commStatus, workflowStatus, type, typeClass, scheduleStatus) {
  payload['commStatus'] = commStatus;
  payload['workflowStatus'] = workflowStatus;
  payload['type'] = type;
  payload['typeClass'] = typeClass;
  payload['scheduleStatus'] = scheduleStatus;

  return $.ajax({
    url: '/reaches-submit.action',
    type: "POST",
    data: payload,
  });
}


function downloadBooklet(whichBooklet, whichLanguage) {
  let booklet = ''
  let language = ''
  switch (whichBooklet) {
    case "alcohol":
      booklet = "alcohol"
    break;
    case "cocaine":
      booklet = "cocaine"
    break;
    case "ecstasy":
      booklet = "ecstasy"
    break;
    case "heroin":
      booklet = "heroin"
    break;
    case "lsd":
      booklet = "lsd"
    break;
    case "marijuana":
      booklet = "marijuana"
    break;
    case "meth":
      booklet = "meth"
    break;
    case "painkillers":
      booklet = "painkillers"
    break;
    case "prescription-drugs":
      booklet = "prescription-drugs"
    break;
    case "synthetic-drugs":
      booklet = "synthetic-drugs"
    break;
  }
  let url = `https://narconon-site-download.s3.us-east-2.amazonaws.com/narconon-${booklet}-booklet.pdf`; // Default to heroin
  let redirect = `/get-help/download-${booklet}-booklet-thank-you.html`
  let name = `narconon-${booklet}-booklet.pdf`
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const blobURL = URL.createObjectURL(blob);

      // Create a download link and trigger the download
      const a = document.createElement("a");
      a.href = blobURL;
      a.style = "display: none";
      a.download = name;
      document.body.appendChild(a);
      a.click();

      // Submit to reaches
      const payload = {
        type: "booklet_download",
        name: name,
      };
    })
    .then(() => {
      // Redirect after both operations are complete
      if (!(window.location.href).endsWith(redirect)) {
        window.location.href = redirect;
      }
    })
    .catch(error => {
      console.log("Error during booklet download or submission:", error);
    });
}
